module.exports = __webpack_public_path__ + "ac41f5b85e099bc4764cc82f7511c87a.png";